import { Link } from 'react-router';

import { SITE } from '@config/site';

import styles from './Logo.module.scss';

/**
 * The mark and wordmark, linking home. The mark matches public/favicon.svg.
 * The link is named by its visible text, so the mark stays decorative.
 */
export const Logo = () => (
  <Link to="/" className={styles.logo} viewTransition>
    <svg className={styles.mark} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="logo-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#7c8cff" />
          <stop offset="1" stopColor="#5ee7ff" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill="url(#logo-gradient)" />
      <path
        d="M21 10.5h-7a3.5 3.5 0 0 0 0 7h4a3.5 3.5 0 0 1 0 7h-7"
        fill="none"
        stroke="#06080d"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    <span className={styles.wordmark}>{SITE.name}</span>
  </Link>
);
